import React, { useEffect, useState } from "react";
import {
  Layout,
  Space,
  Table,
  PageHeader,
  Select,
  Button,
  message,
  Avatar,
  Row,
  Col,
} from "antd";
import { useHistory, useRouteMatch } from "react-router-dom";
import { useSelector } from "react-redux";
import R2Footer from "../../../components/Footer";
import "./Customers.scss";
import CustomerService from "../../../services/CustomerService";
import moment from "moment";
import { DownloadCsv } from "./downloadCsv";

const { Content } = Layout;
const { Option } = Select;

const Customers = () => {
  const [customers, setCustomers] = useState([]);
  const [totalPage, setTotalPage] = useState(1);
  const [defaultPage, setDefaultPage] = useState(1);
  // const [restaurants, setRestaurants] = useState([]);
  const [selectedResaturent, setSelectedRestaurant] = useState();
  const restaurants = useSelector((state) => state.user.restaurants);
  const adminRestaurant = useSelector((state) => state.admin);

  const match = useRouteMatch();
  const [state, setState] = useState({});
  const history = useHistory();

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      //   width: 200,
      render: (e, record) => (
        <div className="image-name">
          <Avatar size="large">{record.name?.substring(0, 1)}</Avatar>

          <div className="cust-name">{record.name}</div>
        </div>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Last Orders Date",
      dataIndex: "order_date",
      key: "order_date",
      render: (_, record) => (
        <div>{moment(record.last_order_date).format("MM/DD/yyyy")}</div>
      ),
    },

    // {
    //   title: "",
    //   render: (_, record) => {
    //     return (
    //       <div
    //         className="view-profile"
    //       >
    //        View Profile
    //       </div>
    //     );
    //   },
    // },
  ];

  useEffect(() => {
    if (adminRestaurant) {
      setSelectedRestaurant(adminRestaurant);
      getCustomer(adminRestaurant);
    }
  }, [adminRestaurant]);

  function onChange(value) {
    setSelectedRestaurant(value);
    getCustomer(value);
  }
  const getCustomer = async (id, page = 0) => {
    const data = await CustomerService.getCustomers(id, page);

    setCustomers(data?.customers);
    setTotalPage(data?.total);
  };

  const exportCsv = async () => {
    const data = await CustomerService.getCustomersCsv(adminRestaurant);

    DownloadCsv(data.customers);
  };

  return (
    <Layout className="u-page-layout">
      <Content className="w-full page-padding">
        <Space className="w-full" direction="vertical">
          <PageHeader
           className="page-header-business"
            title={"Customers"}
            extra={[
              <Button
                type="primary"
                className="custom-btn"
                onClick={() => {
                  exportCsv();
                }}
              >
                Export
              </Button>,
            ]}
          />
          <div>
            {/* Filter By Restaurent:
          <Select value={selectedResaturent} style={{ width: 200, marginRight: "25px" }} onChange={onChange}>
										{restaurants && restaurants.map(item => <Option key={item.id} value={item.id}>{item.name}</Option>)}


									</Select> */}
          </div>
        </Space>
        <div className="site-layout-background content-container-business box-shadow-card">
          <Table
            columns={columns}
            className="table-customer overflow-auto"
            dataSource={customers}
            pagination={{
              onChange: (page) => {
                setDefaultPage(page);
                getCustomer(adminRestaurant, page - 1);
              },
              current: defaultPage,
              pageSize: 10,
              total: totalPage,
              hideOnSinglePage: true,
              showSizeChanger: false,
            }}
            onRow={(record, rowIndex) => {
              return {
                onClick: (event) => {
                  history.push(`/business/customer-details/${record.id}`);
                  // setSelectedProduct(record);
                }, // click row
              };
            }}
          />
        </div>
      </Content>
      <R2Footer />
    </Layout>
  );
};

export default Customers;
